var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMyPlaylists(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2719_90400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8571 15.4286H1.14286C0.512381 15.4286 0 14.9162 0 14.2857V1.14286C0 0.512381 0.512381 0 1.14286 0H22.8571C23.4876 0 24 0.512381 24 1.14286V14.2857C24 14.9162 23.4876 15.4286 22.8571 15.4286ZM24 23.1429C24 22.6686 23.6171 22.2857 23.1429 22.2857H0.857143C0.382857 22.2857 0 22.6686 0 23.1429C0 23.6171 0.382857 24 0.857143 24H23.1429C23.6171 24 24 23.6171 24 23.1429ZM24 18.8571C24 18.3829 23.6171 18 23.1429 18H0.857143C0.382857 18 0 18.3829 0 18.8571C0 19.3314 0.382857 19.7143 0.857143 19.7143H23.1429C23.6171 19.7143 24 19.3314 24 18.8571ZM10.4114 5.79238L6.85714 6.30857L9.42857 8.81524L8.82095 12.3543L12 10.6838L15.179 12.3543L14.5714 8.81524L17.1429 6.30857L13.5886 5.79238L12 2.57143L10.4114 5.79238Z",
    fill: "#00C8D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2719_90400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyPlaylists);
export default __webpack_public_path__ + "static/media/IconMyPlaylists.b60de2828187cd98413a16e5787287d6.svg";
export { ForwardRef as ReactComponent };